module.exports = __webpack_public_path__ + "img/icon_bms4.89498a96.jpg";